
import { AppBar, Box, Toolbar } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';

import { ButtonCustom } from "../../../Theme/ButtonStyle";
import { TextAdapterCustom } from "../../../Theme/TextStyle";
import DownloadReport from "../DownloadReport";
import { useAuth } from "../../../hooks/useAuthProvide";

export default function DashboardFooter(props) {
  const {onShowPeriodPicker,selectedPeriodLabel,selectedFrequency,
        site,categoryID,reportFromDate,reportToDate,checkedVariables,
        type, onClickParagon,paragonSiteID, activeParagon, handleParagonEnergySites} = props
  const {user} = useAuth()

  const AUTORIZATED_USERS = ["mirko","marco","yuri.fortini","alessandro.piro",
                            "giacomo.piro","paolo.vitello"]

  return (
    // <AppBar position="fixed" color="transparent" className={classes.appBar}>
    <AppBar position="fixed" color="transparent" 
            sx={{top:"auto", bottom: 0, backgroundColor: 'background.default',}}>
      <Toolbar>
        <ButtonCustom
          color="primary"
          endIcon={<EditIcon />}
          onClick={onShowPeriodPicker}
          className="period-selector">
          <TextAdapterCustom>
            Periodo: {selectedPeriodLabel}, freq: {selectedFrequency}
          </TextAdapterCustom>
        </ButtonCustom>

        {onClickParagon && paragonSiteID === null && <ButtonCustom
                color={activeParagon ? "primary" : "secondary"}
                endIcon={<AlignVerticalBottomIcon />}
                onClick={onClickParagon}
                className="previousPeriod">
          <TextAdapterCustom>
            Paragone
          </TextAdapterCustom>
        </ButtonCustom>}
        {onClickParagon && AUTORIZATED_USERS.includes(user.username) && <ButtonCustom
                color="primary"
                endIcon={<AlignVerticalBottomIcon />}
                onClick={handleParagonEnergySites}
                className="previousPeriod">
          <TextAdapterCustom>
            Paragone con altro punto vendita
          </TextAdapterCustom>
        </ButtonCustom>}
        {/* {isSitesReady && openModal && renderModal()} */}
        
        <Box sx={{flexGrow:1}}/>

        <DownloadReport
          type={type}
          siteID={site.id}
          categoryID={categoryID}
          reportFromDate={reportFromDate}
          reportToDate={reportToDate}
          selectedFrequency={selectedFrequency}
          checkedVariables={checkedVariables}
          // classes={classes}
        />
      </Toolbar>
    </AppBar>
  );
}
